var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("STATEMENT OF ACCOUNT or “SOA”")]),_c('h4',[_vm._v("The statement of account duly issued by HMI on or before the due date of payment reflecting Membership Fees and other monetary obligations, if any, payable by Client.")])])
}]

export { render, staticRenderFns }